export default () => {
  const adGlobals = {}

  const globals = Object.entries(window.$App.globals.ads)
  globals.forEach((global) => (adGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return adGlobals  
}